module.exports = __webpack_public_path__ + "img/Bluparadise_Valencia_Nuria_Daviu_WEB-009.af9cb1fe.jpg";